var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// ADV-268 — Profil "Adresse" tab per Figma "KONTO | 06 Profil · Adresse" (desktop 64199:8234,
// mobile 64199:8339): the address cards (SettingsPage.renderAddressData, "Konto / Adresskarte")
// in a grid of 3 (stacked on mobile), then the dashed "acc-addr-add" tile while fewer than two
// delivery addresses exist. Styles: ../ProfilePage.css (.pf-addr-). Same handlers as before.
import * as React from 'react';
import { observer } from 'mobx-react';
import _get from 'lodash/get';
import plusIcon from '../icons/address-add-plus.svg';
const AddTile = ({ label, onClick }) => (React.createElement("button", { type: 'button', className: 'pf-addr-add', onClick: onClick },
    React.createElement("span", { className: 'pf-addr-add-ic' },
        React.createElement("img", { src: plusIcon, alt: '', width: 26, height: 26 })),
    React.createElement("span", { className: 'pf-addr-add-title' }, label)));
let ProfileTabDataUsage = class ProfileTabDataUsage extends React.Component {
    render() {
        const { t, profileStore, renderAddressData, onContactsEdit } = this.props;
        const isPrivateAddress = _get(profileStore, 'userProfile.privateAddress', null);
        const isDeliveryAddress = _get(profileStore, 'userProfile.deliveryAddresses', null);
        const isDisableAdd = !!isDeliveryAddress && isDeliveryAddress.length === 2;
        return (React.createElement("div", { className: 'pf-addr-grid' },
            isPrivateAddress
                ? renderAddressData(isPrivateAddress, 'privateAddress')
                : React.createElement(AddTile, { label: t('dashboard.titleAddBillingAddress'), onClick: () => onContactsEdit('privateAddress') }),
            !!isDeliveryAddress ? isDeliveryAddress.map((item) => renderAddressData(item, 'deliveryAddress')) : null,
            !isDisableAdd && (React.createElement(AddTile, { label: t('addressCard.addDelivery'), onClick: () => onContactsEdit('deliveryAddress') }))));
    }
};
ProfileTabDataUsage = __decorate([
    observer
], ProfileTabDataUsage);
export default ProfileTabDataUsage;
